<template lang="pug">
.register
  template(v-if="event.options.can_subordinate")
    template(v-if="levelEventInfoText")
      p.mb-4.title.redesignPrimary--text(
        v-html="levelEventInfoText"
      )
    v-card.ev-card.mb-3(flat)
      v-card-text
        template(v-if="event.options.can_subordinate")
          multistep-organizer-select(
            :value="event"
            :mun-id.sync="munId"
            :region-id.sync="regId"
            register
            @input="onEventOrganizerChoose"
          ).mb-3

        template(v-if="event.id && !event.highest_event")
          v-alert(type="error").mb-3  Не найдено вышестоящее мероприятие

  template(v-if="!loading && selectedEvent")
    event-info(:data="selectedEvent")
    event-register-stepper(
      :event="selectedEvent"
      :key="selectedEventKey"
    ).register__stepper

  template(v-else-if="event.id")
    v-alert(
      icon="mdi-information-outline"
      color="accent"
      type="info"
    ).mt-3 Выберите организатора мероприятия
</template>

<script>
import { computed } from 'vue';
import MultistepOrganizerSelect from '@/components/inputs/MultistepOrganizerSelect.vue';
import EventInfo from './EventInfo.vue';
import EventRegisterStepper from './EventRegisterStepper.vue';
import Event from '@/models/list/event';

// REFACTOR: в onOrganizerChoose использовать $models.event

export default {
  components: {
    MultistepOrganizerSelect,
    EventInfo,
    EventRegisterStepper,
  },
  provide() {
    return {
      selectedEvent: computed(() => this.selectedEvent),
      eventOrganizers: computed(() => this.selectedEvent.organizers),
      eventFields: computed(() => this.eventFields),
    };
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      munId: null,
      regId: null,
      selectedEvent: null,
      eventFields: [],
      loading: false,
    };
  },
  computed: {
    selectedEventKey() {
      return this.selectedEvent?.id;
    },
    levelEventInfoText() {
      const { event, selectedEvent } = this;
      if (!event || !selectedEvent) {
        return null;
      }

      return `Вы подаёте заявку на
        <strong>${this.$tc(`event_data.level.stage[${selectedEvent.level.id || selectedEvent.level}]`, 1)}</strong> этап
        <strong>${this.$tc(`event_data.level.plural[${event.level.id}]`)}</strong> мероприятия
        «${event.name}»`;
    },
  },
  watch: {
    async selectedEvent(value) {
      await value.getOrganizers();
    },
  },
  created() {
    if (!this.event.options.can_subordinate) {
      this.selectedEvent = this.event;
    }
  },
  methods: {
    async onEventOrganizerChoose(event) {
      this.selectedEvent = new Event(event);
      // console.log('organizer', organizer);
      // if (!organizer) {
      //   return;
      // }
      // // NOTE: Не уверен, что тут нужен `_or_null`
      // this.loading = true;
      // await this.$rHandler(
      //   this.$api.events.getPublicEvents({
      //     'search[root_event_id]': this.event.highest_event.id,
      //     'search[owner_id]': organizer.user_id,
      //     'search[municipality_id_or_null]': this.munId,
      //     'search[region_id_or_null]': this.regId,
      //     'search[can_subordinate]': 0,
      //     'search[status]': this.$conf.EVENT_STATUS.ACTIVE,
      //     expand: 'address,area,options,organization,highest_event,nominations',
      //   }),
      //   ({ data }) => {
      //     [this.selectedEvent] = data.data;
      //   },
      // );
      // this.loading = false;
    },
  },
};
</script>
